<template>
		<div class="content home-page" style = 'padding-top: 50px;background:url(../../static/images/bg.jpg) no-repeat 0 0;background-size: cover;'>

			<div class="information2">
        <div class="back info" @click="back" style="">
          <img width="70" src="../../static/images/back.png" />
        </div>
				<div class="faq-content" v-if="list!=''">
					<div class="">
						<p class="fs50 ac"><span>{{$t('TC')}}</span></p>
						<p class="mt30" v-html="list"></p>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
export default {
    components:{
		Header
    },
    data() {
        return {
			list:''

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome()
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			that.$parent.loadModal(true);
			let data = {
			  type:'2'
			}
			that.$api.post('/api/index/help',data,r =>{
				that.$parent.returnCode(r,function(){
					if(localStorage.getItem('lang')=='en'){
					  that.list = r.data.content
					}else{
					  that.list = r.data.mm_content
					}
					that.$parent.loadModal(false);
				});

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/termsAndCondition2.vue